import { Injectable } from '@angular/core';
import { switchMap } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as entityViewsActions from '../actions/entitiy-views.actions';
import { EntityViewsApiService } from '../services/entity-views-api.service';

@Injectable()
export class EntityViewsEffects {
    constructor(
        private readonly actions$: Actions,
        private readonly entityViewsApiService: EntityViewsApiService,
    ) { }

    public readonly loadViewCounts$ = createEffect(() => this.actions$.pipe(
        ofType(entityViewsActions.loadViewCounts),
        switchMap(() => this.entityViewsApiService.getUnviewedCounts())
    ));
}